<div id="dimScreen" style="height: 100%;">
    <div class="error-message">
        <h1>{{ errorCode }}</h1>
        <h2>{{ errorMessage1  }}</h2>
        <h3>{{ errorMessage2 }}</h3>
    </div>
</div>  